export default __webpack_public_path__ + "assets/227776ab15097eef8ea8272e08e58517.png";